// @flow
import type {
  Action,
} from 'fc-flow-types/redux'

// Action Types
import {
  SHOW_IMPORT_JOBS_TOOL,
  SHOW_IMPORT_JOBS_POPUP,
} from './constants'

export function showImportJobsTool (): Action<> {
  return {
    type: SHOW_IMPORT_JOBS_TOOL,
  }
}

export function showImportJobsPopup (payload: Object): Action<> {
  return {
    type: SHOW_IMPORT_JOBS_POPUP,
    payload,
  }
}

